<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">ようこそ</div>
      <div class="card-body">
        <p>
          この画面では新規の予約や、予約した内容の確認を行うことができます。
        </p>
        <p class="btn-group-toggle flex-wrap">
          <a href="#reserve" class="btn btn-success mr-1 mb-1">予約の追加する</a>
        </p>
        <p>
          メールアドレスやプロフィール画像の確認・変更は
          <router-link to="/member/profile" dusk="profile" class="btn btn-sm btn-success">設定画面</router-link>
          から行うことができます。
        </p>
      </div>
    </div>

    <div class="card mb-3" id="reserve_info">
      <div class="card-header">予約の確認</div>
      <div class="card-body">
        <ul v-if="reservations.length">
          <li v-for="reservation in reservations">
            {{ moment(reservation.start_datetime).format("M月D日 HH:mm") }}-{{ moment(reservation.end_datetime).format("HH:mm") }}
            ({{ moment(reservation.end_datetime).diff(reservation.start_datetime, 'minutes') }}分)
            <span class="badge badge-success">{{ reservation["program"].room.name }}</span>
            <template v-if="reservation['program'].room_id === 1">
              {{ reservation["program"].name }}
            </template>
            <template v-else-if="reservation['program'].room_id === 2">
              {{ reservation['program_daily_schedule'].name }}
            </template>
            を予約しています

            <button v-if="!reservation.deleted_at" @click.prevent="cancelReservations(reservation)" class="btn btn-sm btn-outline-danger py-0 px-1 mb-1">
              ✕
            </button>
          </li>

          ✕ボタンから予約のキャンセルができます。
        </ul>

        <ul v-else>
          <li v-if="!this.$store.state.loading.isLoading">現在予約はありません</li>
        </ul>

        <div class="mt-2">
          <router-link to="/member/past-reservations" dusk="profile" class="btn btn-sm btn-success">過去の予約</router-link>
        </div>
      </div>
    </div>

    <div class="card" id="reserve">
      <div class="card-header">予約の追加</div>
      <div class="card-body">
        <ul>
          <li>予約をご希望の日付・ルームのボタンを選んでください。予約時間は次画面で選択できます。</li>
          <!--<li>{{ this.$config["reservable_datetime_between"]["farMonths"] }}ヶ月先まで予約できます。</li>-->
          <li>
            ご予約可能件数(※予約消化ごとに新しいご予約が可能になります)<br>
            4times/ベーシック会員様 Terrace1・2あわせて4枠まで<br>
            フリー/フリー+30会員様 Terrace1・2あわせて12枠まで
          </li>
          <li>Terrace2のレッスンスケジュールは毎月20日までに次月分の更新を致します。</li>
        </ul>

        <FullCalendar
            :defaultView="defaultView()"
            :plugins="calendarPlugins"
            :locale="locale"
            :eventOrder="eventOrder"
            :events="calendarEvents"
            :eventRender="eventRender"
            :validRange="validRange"
            height="auto"
            :views="views"
            :class="defaultView()"
        />
      </div>
    </div>
  </div>
</template>

<style lang='scss'>
/* FullCalendar */
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/list/main.css';

.fc-sun {
  color: red;
  background-color: #fff0f0;
}

.fc-sat {
  color: blue;
  background-color: #f0f0ff;
}

.fc-event {
  display: inline-block;
  background: none;
  border: none;
  padding: 2px;
  color: inherit;
}

.fc-event:hover {
  color: inherit;
}

.fc-event.room {
  cursor: pointer;
}

/* コメントではセル最大まで拡大。ただしmarginがあるため2x2px削る */
.fc-event.notes {
  box-sizing: border-box;
  max-width: calc(100% - 4px);
}

/* コメント中ではセル幅に合わせて行を可能にする */
.fc-event.notes .fc-content {
  white-space: normal;
  overflow-wrap: break-word;
}

/**
 * Listビュー
 */

/* ディスプレイ分の高さをキープして月の切り替え時のガタつきを防ぐ */
.fc-list-view {
  min-height: 100vh;
}

.fc-list-item-time {
  display: none;
}

.fc-list-item-marker {
  display: none;
}

.listMonth .fc-left h2 {
  font-size: 1.25em;
}

.listMonth .fc-toolbar {
  flex-wrap: wrap;
}

</style>

<script>
// FullCalendar
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import listPlugin from '@fullcalendar/list';
import jaLocale from '@fullcalendar/core/locales/ja';
import moment from 'moment';

export default {
  name: "index",
  components: {
    FullCalendar
  },
  data() {
    const vm = this;

    return {
      rooms: null,
      reservations: [],
      dailySchedules: [],

      // カレンダー設定
      calendarPlugins: [
        dayGridPlugin,
        interactionPlugin,
        momentPlugin,
        listPlugin,
      ],
      locale: jaLocale,
      validRange: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().add(2, "months").format('YYYY-MM-DD'),
      },
      views: {
        dayGridMonth: {},
        listMonth: {
          noEventsMessage: ""
        }
      },

      // 解像度によりビューを選択
      defaultView() {
        // bootstrap4 の sm のブレークポイントで分岐
        return (window.innerWidth > 767) ? "dayGridMonth" : "listMonth";
      },

      // カレンダーイベントを生成
      calendarEvents: async function (info, successCallback, failureCallback) {
        vm.$store.commit("loading/setLoading", true);

        let today = moment();
        let start = moment(info.start);
        let end = moment(info.end);

        // 開始日時が今日より前なら開始を今日に設定する
        if (start.isBefore(today)) {
          start = today;
        }

        // デイリースケジュール情報を取得
        let dailySchedules = await vm.getDailySchedules(moment(info.start), moment(info.end));

        // デイリースケジュール情報が取得できなければAPIキャンセルと見なして処理中断
        if (typeof dailySchedules === 'undefined') {
          failureCallback();
        }

        // ルーム情報を取得
        let rooms = await vm.getRooms();

        let calendarData = [];
        let order = 0;
        let classNames = ['room', 'text-white', "bg-success"];
        while (start.diff(end) < 0) {
          // デイリースケジュールのデフォルト値
          let dailySchedule = {
            is_closed: false,
            notes: ""
          };

          // 該当日のデイリースケジュールがあれば選択
          Object.assign(
              dailySchedule,
              dailySchedules.filter((dailySchedule) => {
                return dailySchedule.date === start.format('YYYY-MM-DD');
              }).pop()
          );

          // ルームごとの予約画面へのリンクボタンを生成
          if (!dailySchedule["is_closed"]) {
            for (let room of rooms) {
              calendarData.push({
                id: start.format('YYYY-MM-DD') + "-" + order++,
                title: room.name,
                start: start.format('YYYY-MM-DD'),
                classNames: classNames,
                extendedProps: {
                  type: 'room',
                  roomId: room.id,
                  date: start.format('YYYY-MM-DD'),
                  order: order
                }
              });
            }
          }

          if (dailySchedule["notes"]) {
            // コメント追加
            calendarData.push({
              id: start.format('YYYY-MM-DD') + "-" + order++,
              title: dailySchedule["notes"],
              start: start.format('YYYY-MM-DD'),
              classNames: ["notes", "small"],
              order: order,
            });
          }

          if (dailySchedule["is_closed"]) {
            // 休業日は背景色を変更する
            calendarData.push({
              rendering: 'background',
              start: start.format('YYYY-MM-DD'),
              color: 'gray',
            });
          }

          // 日付を進める
          start.add(1, 'days');
        }

        successCallback(calendarData);

        vm.$store.commit("loading/setLoading", false);
      },

      // カレンダーイベントをorderの順(プッシュした順)で並び替え
      eventOrder: [
        (a, b) => {
          return (a.order > b.order) ? 1 : -1
        }
      ],

      // カレンダーイベントクリック
      eventRender: function (info) {
        info.el.onclick = function () {
          let date = moment(info.event.start).format('YYYY-MM-DD');

          if (info.event.extendedProps.type === "room") {
            let roomId = info.event.extendedProps.roomId;

            vm.$router.push({
              path: `/member/reserve/${roomId}/${date}`,
            });
          }
        };
      },
    }
  },
  activated: function () {
    // このコンポーネントはKeepAliveが設定されているため活性化したときに再取得するためcreatedではなくactivatedで予約情報を取得
    this.getReservations();
  },
  methods: {
    // ルーム情報を取得
    getRooms() {
      // 取得済みであれば保存された値を返す
      if (this.rooms) {
        return this.rooms;
      }

      // ルーム情報を取得
      return axios.get('/member/api/rooms')
          .then(response => {
            this.rooms = response.data.rooms;
            return response.data.rooms;
          })
          .catch(error => this.$store.state.error.code = error.response.status);
    },

    // デイリースケジュール情報を取得
    getDailySchedules(startDateMoment, endDateMoment) {
      // キャンセル用のリクエストID
      const requestId = '/member/api/daily_schedules';

      // 前のリクエストをキャンセル
      axios.cancel(requestId);

      return axios.get('/member/api/daily_schedules', {
        params: {
          start_date: startDateMoment.format('YYYY-MM-DD'),
          end_date: endDateMoment.format('YYYY-MM-DD')
        },
        requestId: requestId
      })
          .then(response => {
            this.dailySchedules = response.data["daily_schedules"];
            return response.data["daily_schedules"];
          })
          .catch(error => {
            // キャンセルであればエラー表示を行わない
            if (!axios.isCancel(error)) {
              this.$store.state.error.code = error.response.status;
            }
          });
    },

    // 予約情報を取得
    getReservations() {
      axios.get('/member/api/reservations')
          .then(response => {
            this.reservations = response.data.reservations;
          })
          .catch(error => this.$store.state.error.code = error.response.status);
    },

    // 予約キャンセル
    cancelReservations(reservation) {
      let dialogBody;

      if (reservation.program["hours_before_reservation_cancel_penalty"]) {
        dialogBody
            = '- ' + reservation.program.room.name + '：予約開始まで' + reservation.program["hours_before_reservation_cancel_penalty"] + '時間を切ったキャンセルはペナルティが発生します。<br>'
            + '- 回数制限のあるプランは、キャンセルした予約も予約回数としてカウントされます。<br>'
            + '- 回数制限のないプランは、当日の未開始の予約と翌日の予約が自動的にキャンセルされ、この２日間への新たな予約は出来ません。<br>'
            + '- キャンセルの取り消しは出来ません。<br>'
      } else {
        dialogBody
            = '- ' + reservation.program.room.name + '：キャンセルのペナルティはありません。<br>'
            + '- キャンセルされた予約は「過去の予約」には表示されません。<br>'
            + '- キャンセルの取り消しは出来ません。<br>'
      }

      this.$dialog.confirm(
          {
            title: "予約をキャンセルしてよろしいですか？",
            body: dialogBody
          }, {
            okText: '予約をキャンセルする',
            cancelText: '戻る',
          }
      ).then(() => {
        axios.put('/member/api/reservations/' + reservation.id + "/cancel")
            .then(response => {
              this.$toasted.show('キャンセルしました');

              // 予約情報を再取得
              this.getReservations();
            })
            .catch((error) => {
                  const {data, status, statusText} = error.response;

                  if (status === 404) {
                    this.$toasted.show('この予約はすでにキャンセルされています', {type: 'error'});

                    // すでに削除済みの予約であれば404レスポンスとなるため情報を再取得する
                    this.getReservations();
                  } else if (status === 422) {
                    // バリデーションエラーであればmessageをそのまま表示する
                    this.$toasted.show(error.response.data.message, {type: 'error'});
                  } else {
                    this.$store.state.error.code = error.response.status;

                    console.log(error.response);

                    // 例外をレスポンス
                    throw (error.response);
                  }
                }
            );
      });
    },
  },
}
</script>
